import React, { useState } from "react";
import { Box, Card } from "@mui/material";
import { useForm } from "react-hook-form";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useSnackbar } from "notistack";

import {
  TextField,
  Button,
  makeStyles,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import changePassword from "images/changePassword.jpg";
import "modules/authentication/change-password/password.scss";

import { forgetSchema } from "./helper";
import {
  apiPaths,
  postData,
} from "modules/platform-components/api-integration-util";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    width: "100%",
    height: 50,
    textTransform: "capitalize",
  },
  back: {
    color: "#3e4095",
    fontSize: 14,
    cursor: "pointer",
  },
  errorMessage: {
    width: "100%",
    "& > p": {
      color: "red",
    },
  },
}));

const ChangePassword = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [message, setMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { register, handleSubmit, errors }: any = useForm({
    validationSchema: forgetSchema,
  });

  const handleOldPassword = () => setShowOldPassword(!showOldPassword);

  const handlePasswordVisibility = () => setShowPassword(!showPassword);

  const handleConfirmPasswordVisibility = () =>
    setShowConfirmPassword(!showConfirmPassword);

  const onSubmit = async (data) => {
    const body = {
      newPassword: data?.confirmPassword,
      oldPassword: data?.oldPassword,
    };
    try {
      postData(`${apiPaths.changePassword}`, {
        data: body,
      })
        .then((res) => {
          enqueueSnackbar("Successfully changed password", {
            variant: "success",
          });
          localStorage.clear();
          postData(apiPaths.logout, { data: {} });
          window.location.reload();
        })
        .catch((val) => {
          setMessage(val ?? "An error occurred. Please try again later.");
        });
    } catch (error) {
      setMessage("An error occurred. Please try again later.");
    }
  };

  return (
    <Box className="change-wrapper">
      <Card className="card-wrapper">
        <div className="card-inner inner-logo">
          <img src={changePassword} style={{ width: "100%" }} alt="arise" />
        </div>
        <div className="card-inner inner-form">
          <FormControl className={classes.formControl}>
            <TextField
              variant="outlined"
              type={showOldPassword ? "text" : "password"}
              name="oldPassword"
              label="Old Password"
              inputRef={register}
              error={!!errors.oldPassword}
              helperText={errors.oldPassword?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleOldPassword}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showOldPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>

          <FormControl className={classes.formControl}>
            <TextField
              variant="outlined"
              type={showPassword ? "text" : "password"}
              name="password"
              label="Password"
              inputRef={register}
              error={!!errors.password}
              helperText={errors.password?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handlePasswordVisibility}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>

          <FormControl className={classes.formControl}>
            <TextField
              variant="outlined"
              type={showConfirmPassword ? "text" : "password"}
              name="confirmPassword"
              label="Confirm Password"
              inputRef={register}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword?.message}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleConfirmPasswordVisibility}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          <Box
            display="flex"
            justifyContent="flex-end"
            className={classes.errorMessage}
          >
            {message && <FormHelperText>{message}</FormHelperText>}
          </Box>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleSubmit(onSubmit)}
          >
            Change Password
          </Button>
        </div>
      </Card>
    </Box>
  );
};

export default ChangePassword;
